import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";
import {getCurrencyIcons} from "../../../utils/enums.js";

const ShiftsHistoryTripSummary = ({ t, summary }) => {

  return (
    <div className={classNames("shiftsHistoryTripSummary")}>
      <table>
        <tbody>
          <tr>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "ordersDelivered")} />
                {summary.totalOrders || 0}
              </div>
              <div className={classNames("info")}>
                {t("shifts.TOTAL_ORDERS_LABEL")}
              </div>
            </td>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "rides")} />
                {summary.count || 0}
              </div>
              <div className={classNames("info")}>
                {t("shifts.COUNT")}
              </div>
            </td>
            <td>
              <div className={classNames("title")}>
                <div className={classNames("icon", "cashCollected")} />
                {summary.totalPrice}
                <span className={classNames("smallText")}>
                  {getCurrencyIcons(summary.currency)}
                </span>
              </div>
              <div className={classNames("info")}>
                {t("shifts.TOTAL_PRICE_LABEL")}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  summary: state.restaurant.data?.shiftsTrip?.summary || {}
});

export default connect(mapStateToProps)(
  withTranslation()(ShiftsHistoryTripSummary)
);
